import { render } from "./SelectNoshigami.vue?vue&type=template&id=96a4cf64&ts=true"
import script from "./SelectNoshigami.vue?vue&type=script&lang=ts"
export * from "./SelectNoshigami.vue?vue&type=script&lang=ts"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__